/* eslint-disable no-undef */
import React, { useRef, useState } from 'react';
import '../../../scss/_templates.scss'
import EmailEditor from 'react-email-editor';
import TemplatesModal from '../../../components/TemplatesModal'
import { useParams } from 'react-router-dom';
import Maintenance from '../../../functions/logic/Maintenance';
import Spiner from '../../../components/Spiner';
import FormModal from '../../../components/FormModal';
import { useSnackbar } from 'notistack';


export default function CreateTemplatess() {
    const [spiner, setSpiner] = useState(false);
    const emailEditorRef = useRef(null);
    const [isOpenHtml, setIsOpenHtml] = useState(false)
    const [bodyHtml, setBodyHtml] = useState('')
    const param = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const userToken = localStorage.getItem('userToken');
    const [isOpenModalform, setIsOpenModalForm] = useState(false);

    const exportHtml = () => {
        emailEditorRef.current.editor.exportHtml((data) => {// design json
            const html = data.html
            setIsOpenHtml(true)
            setBodyHtml(html)
        });
    };

    const handledSaveTemplate = async (html, design, data) => {
        setSpiner(true);
        const response = await Maintenance.saveTemplatesLogic(userToken, param.moduleId, html, design, data);
        if (!response.error) {
            setSpiner(false);
            setIsOpenModalForm(false)
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        } else {
            setSpiner(false);
            enqueueSnackbar(response.message, {
                variant: "error",
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        }
        setSpiner(false);
    }


    const saveTemplate = (event) => {
        event.preventDefault();
        // Do something with the json and html
        emailEditorRef.current.editor.exportHtml((data) => {
            const html = data.html
            const design = data.design
            handledSaveTemplate(html, design, event.target)
        })
    };

    const setDetailsTemlpate = () => {
        setIsOpenModalForm(true);
    }

    const handleCloseModal = () => {
        setIsOpenHtml(false);
        setIsOpenModalForm(false);
    }

    const onLoad = () => {
        // editor instance is created
        // you can load your template here;
        // const templateJson = {};
        // emailEditorRef.current.editor.loadDesign(templateJson);
    }

    const onReady = () => {
        console.log('onReady');
    };

    return (
        <>
            <Spiner opt={spiner} />
            <FormModal
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={'Guardar Template'}
                button={'Guardar'}
                formData={''}
                handledSave={saveTemplate}
                opt={'templates'}
            />
            <TemplatesModal
                isOpen={isOpenHtml}
                body={bodyHtml}
                button={"cerrar"}
                handleCloseModal={handleCloseModal} />
            <div className="card">
                <div className="card-header">
                    <button className="btn btn-primary btn-sm" onClick={exportHtml}>
                        <i className="fas fa-eye"></i>
                    </button>
                    <>&nbsp;&nbsp;</>
                    <button className="btn btn-success btn-sm" onClick={setDetailsTemlpate}>
                        <i className="fas fa-save"></i>
                    </button>
                </div>
                <div className="card-body">
                    <div className='col-md-12'>
                        <EmailEditor
                            ref={emailEditorRef}
                            onLoad={onLoad}
                            onReady={onReady}
                            locale={'es-ES'}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
